import React, { useRef, useState } from "react";
import { Divider, makeStyles, Tooltip } from "@material-ui/core";
import { FileCopyOutlined } from "@material-ui/icons";

import { i18n } from "../../translate/i18n";
import PixLogoImg from "../../assets/miscPng/pix_logo.png";

const useStyles = makeStyles((theme) => ({
  //  ********************
  //  ** Main Container **
  //  ********************
  pixMainContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "5px",
  },

  pixMainContainerStatic: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "3px",
  },

  //  ***********************
  //  ** Content Container **
  //  ***********************
  pixContentContainer: {
    width: "100.00%",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      gap: "5px",
      borderRadius: "5px",
      padding: "3px",
  },

  pixContentLogoContainer: {
    borderRadius: "50.00%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.palette.primary.quotedMessageBox,
  },

  pixLogo: { width: "50px", height: "50px", },

  pixContentKeyContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "3px",
  },

  pixName: { fontWeight: "bold", fontSize: "1.25em", },

  pixNameStatic: { fontWeight: "bold", fontSize: "1.00em", },

  pixKey: { fontSize: "0.95em", },

  //  **********************
  //  ** Button Container **
  //  **********************
  pixButtonContainer: {
    width: "100.00%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: "3px",
    cursor: "pointer",
    transition: "all 0.30s ease",
    color: theme.palette.secondary.ackCheck,
    "&:hover": { opacity: "0.80", },
  },

  floatingButton: {
    transition: "transform 0.3s",
    "&:hover": { transform: "translateY(-5px)", },
  },
}));

const StaticPixComponent = ({ classes, message }) => {
  //  ************
  //  ** Return **
  //  ************
  return (
    <div className={classes.pixMainContainerStatic}>
      <span className={classes.pixNameStatic}>{message.namePix}</span>
      <span className={classes.pixKey}>{message.typePix}: {message.keyPix}</span>
    </div>
  );
};

const InteractivePixComponent = ({ classes, message }) => {
  //  ***************
  //  ** Variables **
  //  ***************
  const [isKeyCopied, setIsKeyCopied] = useState(false);
  const timeoutCopyRef = useRef(null);



  //  ***************
  //  ** Functions **
  //  ***************
  const handleCopyPixKey = async () => {
    setIsKeyCopied(true);
    await navigator.clipboard.writeText(message.keyPix);
    
    if (timeoutCopyRef.current) clearTimeout(timeoutCopyRef.current);
    timeoutCopyRef.current = setTimeout(() => setIsKeyCopied(false), 750);
  };



  //  ************
  //  ** Return **
  //  ************
  return (
    <div className={classes.pixMainContainer}>
      <div className={classes.pixContentContainer}>
        <div className={classes.pixContentLogoContainer}>
          <img alt="Pix Logo" src={PixLogoImg} className={classes.pixLogo} />
        </div>

        <div className={classes.pixContentKeyContainer}>
          <span className={classes.pixName}>{message.namePix}</span>
          <span className={classes.pixKey}>{message.typePix}: {message.keyPix}</span>
        </div>
      </div>

      <Divider />
      <Divider />
      <Divider />

      <Tooltip
        title={isKeyCopied ? i18n.t("pixMessage.tooltips.copied") : ""}
        placement="top-middle"
        arrow
      >
        <div className={`${classes.pixButtonContainer} ${classes.floatingButton}`} onClick={async () => await handleCopyPixKey()}>
          <FileCopyOutlined />
          <span>{i18n.t("pixMessage.buttons.copyKey")}</span>
        </div>
      </Tooltip>
    </div>
  );
};

const PixMessage = ({ message, isQuoted }) => {
  //  ***************
  //  ** Variables **
  //  ***************
  const classes = useStyles()



  //  ************
  //  ** Return **
  //  ************
  if (isQuoted) return <StaticPixComponent classes={classes} message={message} />;
  else return <InteractivePixComponent classes={classes} message={message} />;
};

export default PixMessage;
